import { getCountryByCurrency } from '@utils/locations';

import { COUNTRIES } from '../constants/locations';
import { CurrencyCode } from '../types/Locations';

export const formatPrice = (
  amount: number,
  currency: CurrencyCode,
  isFloat: boolean = false,
) => {
  const countryCode = getCountryByCurrency(currency);
  const options: Intl.NumberFormatOptions = {
    style: 'currency',
    currency,
    maximumFractionDigits: isFloat ? 2 : 0,
    minimumFractionDigits: isFloat ? 2 : 0,
  };

  try {
    return new Intl.NumberFormat(`en-${countryCode}`, options).format(amount);
  } catch {
    return amount;
  }
};

export function normaliseShopifyPrice(price: number, currency: CurrencyCode) {
  const selectedCountry = getCountryByCurrency(currency);
  if (!selectedCountry) {
    console.warn('Failed to normalise price - could not find selected country');
    return price;
  }
  return price / COUNTRIES[selectedCountry].minorUnit;
}
